import { MutableRefObject, useCallback, useMemo, useRef } from 'react';

type LastFiredEvent = {
  lastSearchRequestId: MutableRefObject<string>;
  updateLastSearchRequestId: (searchRequestId: string) => void;
};

export default function useLastSearchRequestId() {
  const lastSearchRequestId = useRef('');

  const updateLastSearchRequestId = useCallback((searchRequestId: string) => {
    lastSearchRequestId.current = searchRequestId;
  }, []);

  return useMemo<LastFiredEvent>(
    () => ({
      lastSearchRequestId,
      updateLastSearchRequestId
    }),
    [lastSearchRequestId, updateLastSearchRequestId]
  );
}
